/**
 * Mirrors the backend `CplNoteVisbility`.
 *
 * The member names describe an audience, which is the historical conflation behind EDLP-3578: the
 * stored value drives BOTH who may read a note and who the note is addressed to. Those agree when an
 * approver writes the note and invert when the request's own user does, so the backend now derives the
 * value from who performed the action. Read these as *addressed party*:
 *
 * - `Supervisor` — addressed to the approver(s)
 * - `EndUser`    — addressed to the request's user
 */
export enum NoteVisibility {
    Supervisor = 0,
    EndUser = 1
}
